import { History, Location } from "history";
import { AxiosInstance } from "axios";
import { failure, ok, pending, Result } from "../../common/common";
import { makeAutoObservable } from "mobx";
import { prepChangePasswordForm } from "./userSettingsDomain";
import { TMessage } from "../../i18n/tt";
import { StringFieldModel } from "../../common/commonForms";

export type ApplyCreatePasswordRequest = {
  ref?: string;
  username?: string;
  password?: string;
};

export function prepApplyCreatePasswordPayload({
  username,
  password,
  confirmedPassword,
  location,
}: {
  username: StringFieldModel;
  password: StringFieldModel;
  confirmedPassword: StringFieldModel;
  location: Location;
}): ApplyCreatePasswordRequest | undefined {
  if (username.validate() && password.validate() && confirmedPassword.validate()) {
    return {
      ref: new URLSearchParams(location.search).get("ref") ?? undefined,
      username: username.validatedValue,
      password: password.validatedValue,
    };
  }
}

export class CreatePasswordStore {
  http: AxiosInstance;
  history: History;
  username: StringFieldModel;
  password: StringFieldModel;
  confirmedPassword: StringFieldModel;
  result?: Result<void, TMessage>;

  constructor(http: AxiosInstance, history: History) {
    makeAutoObservable(this, { http: false, history: false }, { autoBind: true });
    this.http = http;
    this.history = history;
    const { newPassword, confirmedPassword } = prepChangePasswordForm();
    this.password = newPassword;
    this.confirmedPassword = confirmedPassword;
    this.username = new StringFieldModel({ required: true });
  }

  *save() {
    const payload = prepApplyCreatePasswordPayload({
      username: this.username,
      password: this.password,
      confirmedPassword: this.confirmedPassword,
      location: this.history.location,
    });
    if (!payload) {
      return;
    }
    this.result = pending();
    try {
      yield this.http.post("/user-settings/apply-create-password", payload);
      this.result = ok();
    } catch (err) {
      this.result = failure({ key: "user-settings.create-password-failure-message" });
    }
  }
}
